/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     客户数据管理
  +--------------------------------------------------------------------------------------
*/

import Vue from "vue";
import {
  editEnterpriseApi,
  getEnterpriseDetailApi,
  postSettingApi
} from "@/api/sys/enterpriseApi";

const godStore = {
  state: {
    god_setting: {},

  },

  mutations: {
    SET_GOD: (state, god) => {
      Object.keys(god).forEach(item => {
        Vue.set(state, item, god[item]);
      });
    },

    SET_GOD_SETTING: (state, god_setting) => {
      state.god_setting = Object.assign({}, state.god_setting, god_setting);
    },
  },

  actions: {
    // 设置客户信息
    setGodInfomationAction ({ commit, state, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        editEnterpriseApi(formData)
          .then(res => {
            if (!res.errno) {
              dispatch("getUserInfoAction");
              dispatch("getGodInfoAction").then(r => resolve(res));
            } else {
              resolve(res);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    getGodInfoAction ({ commit, state }) {
      return new Promise((resolve, reject) => {
        getEnterpriseDetailApi()
          .then(res => {
            if (!res.errno) {
              commit("SET_GOD", res.data);
            }
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    // 设置客户个性化
    setGodCustomizationAction ({ commit, state, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        editEnterpriseApi(formData)
          .then(res => {
            if (!res.errno) {
              // getGodInfoAction()
              dispatch("getUserInfoAction").then(() => { });
            }
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },


    //设置大屏title
    setDbTitle ({ commit, state, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        postSettingApi(formData)
          .then(res => {
            if (!res.errno) {
              dispatch("getGodInfoAction").then(() => { });
            }
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  }
};

export default godStore;
